<template>
  <transition name="drawer">
    <div v-if="isOpen" class="drawer" :style="{ height: windowHeight }">
      <div class="header">
        <div class="titleArea">
           {{winner.name}}さんへの<br>
           応援メッセージ・感想（{{commentCount ? commentCount : 0}}件）
        </div>
        <div class="close" @click="closeDrawer">
          <img data-v-1f96d445="" src="/img/close.png" srcset="/img/close@2x.png 2x" alt="" class="closeButtonImage">
        </div>
      </div>
      <div class="messageArea" :class="{ commentAreaOn: isOpenCommentArea }">

        <div v-if="!comments || comments.length === 0" class="noMessage">現在メッセージはありません。</div>

        <div v-else v-for="(comment, index) in comments" :key="comment.id" class="commentFrame"  :style="{ backgroundColor: index % 2 == 1 ? '#efefef' : '#ffffff' }">
          <div class="comment" :ref="'id' + comment.id">
            <div class="commentText">
              <div v-if="comment.displayLinkUrl && comment.displayLinkText" class="reference">
                <img src="/img/arwRight.png" alt="" class="rightCursor">
                <span @click="goReference(comment.displayLinkUrl)">{{comment.displayLinkText}}</span>
              </div>
              <div class="textArea">{{comment.sentence}}</div>
              <div class="nameArea">
                名前: {{comment.postName}}
                <img v-if="comment.isWinner" src="/img/commentAuthenticated.png" alt="" class="authenticated">
                &nbsp;&nbsp;{{displayDate(comment.createdAt)}}
                <template v-if="isOpenExhibition">
                &nbsp;<button v-if="!winner.isLockedWinner" @click.stop="openReplyArea(comment)" :disabled="isOpenReplyArea || isOpenCommentArea" :class="{ disabled: isOpenReplyArea || isOpenCommentArea }">返信</button>
                </template>
              </div>
            </div>
          </div>

          <div v-if="comment.children && comment.children.length > 0" class="childArea">
            <div v-for="child in comment.children" :key="child.id" class="childFrame">
              <div class="child" :ref="'id' + child.id">
                <div class="commentText">
                  <div class="textArea">{{child.sentence}}</div>
                  <div class="nameArea">
                    名前: {{child.postName}}
                    <img v-if="child.isWinner" src="/img/commentAuthenticated.png" alt="" class="authenticated">
                    &nbsp;&nbsp;{{displayDate(child.createdAt)}}
                    <template v-if="isOpenExhibition">
                    &nbsp;<button v-if="!winner.isLockedWinner" @click.stop="openReplyArea(comment)" :disabled="isOpenReplyArea || isOpenCommentArea" :class="{ disabled: isOpenReplyArea || isOpenCommentArea }">返信</button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="replyArea">
            <div v-if="comment.isOpenReplyArea" class="commentArea">
              <div class="inputArea" v-if="!isOpenConfirmArea">
                <div class="nameArea">
                  <template v-if="me && me.name">
                    名前: {{me.name}}
                    <img src="/img/commentAuthenticated.png" alt="" class="authenticated">
                    <button @click.stop="signout" class="signout">サインアウト</button>
                  </template>
                  <template v-else>
                    <input type="text" name="personName" v-model="name" class="inputText" placeholder="お名前" />
                  </template>
                </div>
                <div class="sentenceArea">
                  <textarea name="sentence" v-model="sentence" rows="8" cols="50" class="inputTextbox" id="sentence" placeholder="メッセージ"></textarea>
                </div>
                <div v-if="isError" class="errorArea">
                  <div v-if="errorMessage">{{errorMessage}}</div>
                  <div v-if="errorMessageName">{{errorMessageName}}</div>
                  <div v-if="errorMessageSentence">{{errorMessageSentence}}</div>
                </div>
                <div class="buttonArea">
                  <div>
                    <button @click="closeReplyArea(comment)" class="buttonCancel">
                      キャンセル
                    </button>
                  </div>
                  &nbsp;
                  <div>
                    <button @click="confirmComment(comment)" class="buttonSubmit">
                      書き込みを確認
                    </button>
                  </div>
                </div>
              </div>
              <div class="confirmArea" v-if="isOpenConfirmArea && !isOpenCompleteArea">
                <template v-if="me && me.name">
                    <div class="nameArea">{{name}} <img src="/img/commentAuthenticated.png" alt="" class="authenticated"></div>
                </template>
                <template v-else>
                  <div class="nameArea">{{name}}</div>
                </template>
                <div class="sentenceArea">{{sentence}}</div>
                <div class="buttonArea">
                  <div>
                    <button @click="closeConfirmArea" class="buttonCancel">
                      戻る
                    </button>
                  </div>
                  &nbsp;
                  <div>
                    <button @click="postComment(comment)" class="buttonSubmit" :disabled="isProcessing">
                      書き込みを登録
                    </button>
                  </div>
                </div>
              </div>
              <div class="completeArea" v-if="isOpenCompleteArea">
                <div class="complateText">
                  メッセージありがとうございます。<br>送信が完了しました。<br>
                  メッセージは、受信者が内容を確認し、「公開」設定をすると反映されます。<br>
                  反映まで今しばらくお待ちください。<br>
                </div>
                <div class="buttonArea">
                  <div>
                    <button @click="closeCompleteArea(comment)" class="buttonCancel">
                      閉じる
                    </button>
                  </div>
                </div>
              </div>
              <div class="notice">
                東京カメラ部2021写真展をご覧いただいた方や展示者の方どうしが自由にメッセージのやり取りしていただける機能です。<br>
                他の利用者、または第三者に不利益を与える内容や、誹謗中傷、法律違反、その他事務局が不適切な内容であると判断した場合は、コメントを非表示・または削除することがあります。また、やむを得ない場合は、会期途中であっても本機能のすべてまたは一部を事前の予告なく中止させていただく場合があります。<br>
                応援メッセージ・感想はGoogleのreCAPTCHAによって保護されています。Googleの <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>と<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">利用規約</a>が適用されます。<br>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="footer" :class="{ commentAreaOn: isOpenCommentArea }">
        <div v-if="isOpenCommentArea" class="commentArea">
          <div class="inputArea" v-if="!isOpenConfirmArea">
            <div class="nameArea">
              <template v-if="me && me.name">
                名前: {{me.name}}
                <img src="/img/commentAuthenticated.png" alt="" class="authenticated">
                <button @click.stop="signout" class="signout">サインアウト</button>
              </template>
              <template v-else>
                <input type="text" name="personName" v-model="name" class="inputText" placeholder="お名前" />
              </template>
            </div>
            <div class="sentenceArea">
              <textarea name="sentence" v-model="sentence" rows="8" cols="50" class="inputTextbox" id="sentence" placeholder="メッセージ"></textarea>
            </div>
            <div v-if="isError" class="errorArea">
              <div v-if="errorMessage">{{errorMessage}}</div>
              <div v-if="errorMessageName">{{errorMessageName}}</div>
              <div v-if="errorMessageSentence">{{errorMessageSentence}}</div>
            </div>
            <div class="buttonArea">
              <div>
                <button @click="closeCommentArea" class="buttonCancel">
                  キャンセル
                </button>
              </div>
              &nbsp;
              <div>
                <button @click="confirmComment" class="buttonSubmit">
                  書き込みを確認
                </button>
              </div>
            </div>
          </div>
          <div class="confirmArea" v-if="isOpenConfirmArea && !isOpenCompleteArea">
            <template v-if="me && me.name">
                <div class="nameArea">{{name}} <img src="/img/commentAuthenticated.png" alt="" class="authenticated"></div>
            </template>
            <template v-else>
              <div class="nameArea">{{name}}</div>
            </template>
            <div class="sentenceArea">{{sentence}}</div>
            <div class="buttonArea">
              <div>
                <button @click="closeConfirmArea" class="buttonCancel">
                  戻る
                </button>
              </div>
              &nbsp;
              <div>
                <button @click="postComment" class="buttonSubmit" :disabled="isProcessing">
                  書き込みを登録
                </button>
              </div>
            </div>
          </div>
          <div class="completeArea" v-if="isOpenCompleteArea">
            <div class="complateText">
              メッセージありがとうございます。<br>送信が完了しました。<br>
              メッセージは、受信者が内容を確認し、「公開」設定をすると反映されます。<br>
              反映まで今しばらくお待ちください。<br>
            </div>
            <div class="buttonArea">
              <div>
                <button @click="closeCompleteArea" class="buttonCancel">
                  閉じる
                </button>
              </div>
            </div>
          </div>
          <div class="notice">
            東京カメラ部2021写真展をご覧いただいた方や展示者の方どうしが自由にメッセージのやり取りしていただける機能です。<br>
            他の利用者、または第三者に不利益を与える内容や、誹謗中傷、法律違反、その他事務局が不適切な内容であると判断した場合は、コメントを非表示・または削除することがあります。また、やむを得ない場合は、会期途中であっても本機能のすべてまたは一部を事前の予告なく中止させていただく場合があります。<br>
            応援メッセージ・感想はGoogleのreCAPTCHAによって保護されています。Googleの <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>と<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">利用規約</a>が適用されます。<br>
          </div>
        </div>
        <div v-if="!isOpenCommentArea" class="openButtonArea">
          <template v-if="isOpenExhibition">
          <button @click="openCommentArea" class="button" :disabled="isOpenReplyArea || isOpenCommentArea" :class="{ disabled: isOpenReplyArea || isOpenCommentArea }">
            メッセージを書く
          </button>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import { mapGetters } from 'vuex'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import { CommentsApi, MeApi } from '../../api'
import TokenUtil from '@/util/TokenUtil'
import moment from 'moment'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  props: [
    'isOpen',
    'winner',
    'goReference',
    'close'
  ],
  data () {
    return {
      comments: null, // コメントのリスト
      me: null, // 受賞者ログインしていた場合、ここに受賞者情報が設定される
      // 書き込みエリア
      isOpenReplyArea: false,
      isOpenCommentArea: false,
      isOpenConfirmArea: false,
      isOpenCompleteArea: false,
      isProcessing: false,
      // テキストボックス
      name: '',
      sentence: '',
      // ドロワー高さ
      windowHeight: '100vh',
      // パラメータ
      displayLinkUrl: '',
      displayLinkText: '',
      // エラー
      isError: false,
      errorMessage: '',
      errorMessageName: '',
      errorMessageSentence: '',
      // コメント件数
      commentCount: 0,
      // 開催状況
      isOpenExhibition: true
    }
  },
  mounted () {
    // ウインドウ幅変更イベントリスナー登録
    window.addEventListener('resize', this.handleResize)
    // サイズ情報設定
    this.handleResize()
  },
  beforeDestroy: function () {
    // ウインドウ幅変更イベントリスナー解除
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // コメント情報読み出し
    async loadComments () {
      if (!this.winner || !this.winner.isComment) return
      // コメント呼び出し
      await CommentsApi.getComments(this.winner.id)
        .then(response => {
          this.comments = response
          // コメント件数をカウント
          if (this.comments && this.comments.length > 0) {
            this.commentCount = 0
            for (const comment of this.comments) {
              this.commentCount++;
              if (comment.children && comment.children.length > 0) {
                this.commentCount += comment.children.length
              }
            }
          }
        })
        .catch(() => {
          // コメントが取得できない場合は、コメントをクリア
          this.comments = null
        })
      // 出展者情報の取得
      // 管理者トークンがあるか
      if (TokenUtil.isAdminLogin()) { // 管理者トークンが存在した場合ユーザー情報を取得
        await MeApi.me()
          .then((result) => {
            this.me = result.data.winner
          })
          .catch(() => {
            // トークンが無効になっていた場合はクリアする
            this.me = null
            TokenUtil.remove()
          })
      }
    },
    async setDisplayLinkInfo () {
      // 現在の画面の情報を設定する
      this.displayLinkUrl = `${location.protocol}//${location.host}${this.$route.path}`
      if (this.$route.path.indexOf('/images/') >= 0) {
        this.displayLinkText = '作品詳細'
      } else if (this.$route.path.indexOf('/portfolios/') >= 0) {
        this.displayLinkText = 'ポートフォリオ'
      } else {
        this.displayLinkText = '作品展示ページ'
      }
    },
    signout () {
      if (confirm('サインアウトします。よろしいですか？')) {
        this.me = null
        TokenUtil.remove()
      }
    },
    closeDrawer () {
      this.closeCompleteArea()
      this.closeConfirmArea()
      this.closeCommentArea()
      this.close()
    },
    openCommentArea () {
      this.isOpenCommentArea = true
    },
    closeCommentArea () {
      this.clear()
    },
    closeConfirmArea () {
      this.isOpenConfirmArea = false
    },
    closeCompleteArea (comment = null) {
      this.closeConfirmArea()
      this.closeCommentArea()
      this.isOpenCompleteArea = false
      if (comment) {
        this.closeReplyArea(comment)
      }
    },
    openReplyArea (comment) {
      this.$set(comment, 'isOpenReplyArea', true)
      this.isOpenReplyArea = true
    },
    closeReplyArea (comment) {
      this.clear()
      this.$set(comment, 'isOpenReplyArea', false)
      this.isOpenReplyArea = false
    },
    clear () {
      this.name = ''
      this.sentence = ''
      this.errorMessage = ''
      this.errorMessageName = ''
      this.errorMessageSentence = ''
      this.isOpenCommentArea = false
    },
    // 確認処理
    confirmComment (parentComment) {
      if (TokenUtil.isAdminLogin()) {
        this.adminConfirmComment(parentComment) // 受賞者ログイン状態の時の処理
      } else {
        this.openConfirmComment(parentComment) // 通常書き込みの処理
      }
    },
    openConfirmComment (parentComment) {
      this.name = this.name ? this.name.trim() : ''
      this.sentence = this.sentence ? this.sentence.trim() : ''

      // 表示用リンク情報生成
      this.setDisplayLinkInfo()

      // 確認API呼び出し
      CommentsApi.postCommentConfirm({
        winnerId: this.winner.id,
        postName: this.name,
        sentence: this.sentence,
        displayLinkUrl: this.displayLinkUrl,
        displayLinkText: this.displayLinkText,
        parentCommentId: parentComment ? parentComment.id : null
      }).then((result) => {
        // this.clearForm()
        this.isOpenConfirmArea = true // 確認画面に切り替え
        this.commentConfirm = result.data.comment

        // イベント記録
        this.$ga.event('Comment', 'confirm', 'message', this.winner.id)
      }).catch((error) => {
        console.error(error)
        this.isError = true
        this.errorMessage = error.result.message
        this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
        this.errorMessageName = (this.errorMessageName ? 'お名前: ' + this.errorMessageName : null)
        this.errorMessageSentence = this.getErrorMessage('sentence', error.result.errors)
        this.errorMessageSentence = (this.errorMessageSentence ? 'メッセージ: ' + this.errorMessageSentence : null)
      })
    },
    adminConfirmComment (parentComment) {
      this.name = this.name ? this.name.trim() : ''
      this.sentence = this.sentence ? this.sentence.trim() : ''

      // 受賞者本人書き込み処理
      if (this.me && this.me.name) {
        this.name = this.me.name
      }

      // 表示用リンク情報生成
      this.setDisplayLinkInfo()

      // 確認API呼び出し
      CommentsApi.adminPostCommentConfirm({
        winnerId: this.winner.id,
        postName: this.name,
        isWinner: true,
        sentence: this.sentence,
        displayLinkUrl: this.displayLinkUrl,
        displayLinkText: this.displayLinkText,
        parentCommentId: parentComment ? parentComment.id : null
      }).then((result) => {
        // this.clearForm()
        this.isOpenConfirmArea = true // 確認画面に切り替え
        this.commentConfirm = result.data.comment

        // イベント記録
        this.$ga.event('Comment', 'confirm', 'message', this.winner.id)
      }).catch((error) => {
        console.error(error)
        this.isError = true
        if (error && error.response && error.response.status == 401) {
          // 認証エラーだった場合に認証情報クリアしてエラー表示
          this.me = null
          TokenUtil.remove()
          this.name = null
          this.errorMessageSentence = 'サインアウトされたか、サインイン期間が終了しました。認証付きで書き込む場合は、マイページより再度ログインしてください。'
        } else {
          this.errorMessage = error.result.message
          this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
          this.errorMessageName = (this.errorMessageName ? 'お名前: ' + this.errorMessageName : null)
          this.errorMessageSentence = this.getErrorMessage('sentence', error.result.errors)
          this.errorMessageSentence = (this.errorMessageSentence ? 'メッセージ: ' + this.errorMessageSentence : null)
        }
      })
    },
    // 投稿処理
    async postComment (parentComment) {
      if (TokenUtil.isAdminLogin()) {
        this.adminPostComment(parentComment) // 受賞者ログイン状態の時の処理
      } else {
        this.openPostComment(parentComment) // 通常書き込みの処理
      }
    },
    async openPostComment (parentComment) {
      this.isProcessing = true
      // reCAPTCHA読み出し
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('comment') // reCAPTCHAのトークン取得

      // 表示用リンク情報生成
      this.setDisplayLinkInfo()

      // 書き込み処理
      CommentsApi.postComment({
        winnerId: this.winner.id,
        postName: this.name,
        sentence: this.sentence,
        displayLinkUrl: this.displayLinkUrl,
        displayLinkText: this.displayLinkText,
        parentCommentId: parentComment ? parentComment.id : null,
        recaptchaToken: token
      }).then(() => {
        this.isOpenCompleteArea = true // 投稿完了メッセージに切り替え

        // イベント記録
        this.$ga.event('Comment', 'write', this.winner.id, this.winner.id)
        this.isProcessing = false
      }).catch((error) => {
        this.isError = true
        this.errorMessage = error.result.message
        this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
        this.errorMessageName = (this.errorMessageName ? 'お名前: ' + this.errorMessageName : null)
        this.errorMessageSentence = this.getErrorMessage('sentence', error.result.errors)
        this.errorMessageSentence = (this.errorMessageSentence ? 'メッセージ: ' + this.errorMessageSentence : null)
        this.isProcessing = false
      })
    },
    async adminPostComment (parentComment) {
      this.isProcessing = true
      // 管理側はreCAPTCHA処理なし

      // 受賞者本人書き込み処理
      if (this.me && this.me.name) {
        this.name = this.me.name
      }

      // 表示用リンク情報生成
      this.setDisplayLinkInfo()

      // 書き込み処理
      CommentsApi.adminPostComment({
        winnerId: this.winner.id,
        postName: this.name,
        isWinner: true,
        sentence: this.sentence,
        displayLinkUrl: this.displayLinkUrl,
        displayLinkText: this.displayLinkText,
        parentCommentId: parentComment ? parentComment.id : null,
      }).then(() => {
        this.isOpenCompleteArea = true // 投稿完了メッセージに切り替え

        // イベント記録
        this.$ga.event('Comment', 'write', 'message', this.winner.id)
        this.isProcessing = false

        // 自分のコメント欄に投稿した場合は、メッセージの再読み込みを行う
        if (this.me.id == this.winner.id) {
          this.closeCompleteArea(parentComment)
          this.loadComments()
        }
      }).catch((error) => {
        this.isError = true
        this.errorMessage = error.result.message
        this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
        this.errorMessageName = (this.errorMessageName ? 'お名前: ' + this.errorMessageName : null)
        this.errorMessageSentence = this.getErrorMessage('sentence', error.result.errors)
        this.errorMessageSentence = (this.errorMessageSentence ? 'メッセージ: ' + this.errorMessageSentence : null)
        this.isProcessing = false
      })
    },
    displayDate (date) {
      return moment(date).format('YYYY.MM.DD HH:mm')
    },
    beforeEnterHeader (el) {
      // el.style.height = '0'
    },
    enterHeader (el) {
      // el.style.height = el.scrollHeight + 'px'
    },
    beforeLeaveHeader (el) {
      // el.style.height = el.scrollHeight + 'px'
    },
    leaveHeader (el) {
      // el.style.height = '0'
    },
    handleResize () {
      this.windowHeight = window.innerHeight + 'px'
    },
    getErrorMessage (field, errors) {
      for (const error of errors) {
        if (error.field === field) {
          return error.code
        }
      }
    },
    // 写真展オープン中か、本番環境以外の場合、フラグにtrueを設定
    async checkOpenExhibition () {
      // UNIXタイムスタンプの現在時
      const now = new Date().getTime() / 1000
      const host = 'https://exh2021.tokyocameraclub.com'
      this.isOpenExhibition = (location.href.indexOf(host) < 0 || now <= 1639234799)
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
        // 初期化
        this.clear()
        this.comments = []
        this.commentCount = 0
        // コメント読み込み
        this.loadComments()

        // 開催状況判定
        this.checkOpenExhibition()

        // iPhone iOS15 safariのバグで、下部アドレスバーが非表示になったのに、
        // 下部アドレスバーの高さを計算して値が帰ってきてしまい、不要な空白ができて
        // ドロワーの下部を隠してしまう問題に対応するため、iPhoneの場合は、ドロワーを
        // 表示した後、遅延して、高さを再計算して表示するようにした
        setTimeout(() => {
          this.handleResize()
        }, 200)
      } else {
        this.clear()
      }
    }
  }
}

</script>

<style scoped>
.drawer {
  position: fixed;
  height: 100vh;
  top: 0px;
  bottom: 0px;
  right: 0px;
  width: 400px;
  background-color: #666666;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0px 6px 0px rgba(0, 0, 0, 0.3);
  --commentAreaHeight: 360px;
}

/* アニメーション中のスタイル */
.drawer-leave-active,
.drawer-enter-active {
  transition: right 0.3s;
}

.drawer-leave-active,
.drawer-enter-active {
  transition: right 0.3s;
}

/* 表示アニメーション */
.drawer-enter {
  right: -400px;
}
.drawer-enter-to {
  right: 0px;
}

/* 非表示アニメーション */
.drawer-leave {
  right: 0px;
}
.drawer-leave-to {
  right: -400px;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 64px;
}

.titleArea {
  padding: 16px;
  color: white;
  font-size: 0.8rem;
}

.close {
  position: absolute;
  right: 0px;
  cursor: pointer;
}

.closeButtonImage {
  width: 32px;
  height: 32px;
}

.messageArea {
  position: absolute;
  top: 72px;
  right: 16px;
  bottom: 80px;
  left: 16px;
  background-color: white;
  overflow-y: scroll;
}
.messageArea.commentAreaOn {
  bottom: var(--commentAreaHeight);
}
.footer {
  position: absolute;
  height: 80px;
  right: 16px;
  bottom: 0px;
  left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}
.footer.commentAreaOn {
  height: var(--commentAreaHeight);  
}
.openButtonArea {
  margin-top: 14px;
}
.openButtonArea .button {
  font-size: 0.8rem;
  width: 260px;
  padding: 8px;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
}
.commentFrame {
  width: 100%;
  padding-bottom: 4px;
}

.commentFrame .comment {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.commentFrame .commentText {
  padding: 8px 0px;
  margin: 8px 8px 0px 8px;
}

.childArea {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 12px;
  width: 100%;
}
.childArea .childFrame {
  width: 100%;
}
.childFrame .child {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.childFrame .child .commentText {
  margin-left: 16px;
  padding-left: 16px;
  border-left: 7px solid #cccccc;
}

.commentText .reference {
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

.commentText .reference .rightCursor {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.commentText .reference span {
  font-size: 0.7rem;
  user-select: none;
}

.textArea {
  white-space: pre-wrap;
  font-size: 0.8rem;
}
.nameArea {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.7rem;
  margin-top: 4px;
}
.nameArea button {
  font-size: 0.7rem;
  height: 22px;
  color: white;
  background-color: black;
  border-radius: 6px;
  white-space: nowrap;
}
.authenticated {
  margin-left: 4px;
  width: 14px;
  height: 14px;
}
.commentArea {
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #cccccc;
}
.commentArea .inputArea {
  width: 100%;
}
.commentArea .nameArea {
  width: 100%;
  padding: 8px 8px 0px 8px;
}
.commentArea input {
  box-sizing: border-box;
  margin: 0px;
  width: 100%;
  height: 22px;
}
.commentArea .sentenceArea {
  margin: 8px 0px;
  padding: 0px 8px;
  width: 100%;
}
.commentArea textarea {
  resize: none;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
}
.commentArea .buttonArea {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.commentArea .buttonSubmit {
  font-size: 0.7rem;
  width: 110px;
  padding: 4px;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 14px;
  cursor: pointer;
}
.commentArea .buttonCancel {
  font-size: 0.7rem;
  width: 110px;
  padding: 4px;
  background-color: #666666;
  color: white;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 14px;
  cursor: pointer;
}

.replyArea {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.replyArea .commentArea {
  margin-top: 4px;
  margin-bottom: 4px;
  width: calc(var(--commentAreaHeight) - 16px);
}

.confirmArea {
  width: 100%;
  margin-top: 16px;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #cccccc;
}
.confirmArea .nameArea {
  width: 100%;
  box-sizing: border-box;
  margin: 0px;
  height: 22px;
  padding: 4px 8px 4px 8px;
  border: solid 1px #666666;
  border-radius: 4px;
  text-align: left;
  overflow: hidden;
}
.confirmArea .sentenceArea {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  margin: 8px 0px;
  padding: 0px 8px;
  border: solid 1px #666666;
  border-radius: 4px;
  text-align: left;
  white-space: pre-wrap;
  overflow-y: scroll;
}
.completeArea {
  width: 100%;
  margin-top: 16px;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #cccccc;
}
.completeArea .complateText {
  font-size: 0.8rem;
  width: 100%;
  box-sizing: border-box;
  margin: 0px;
  padding: 4px 8px 16px 8px;
  text-align: center;
  background-color: #cccccc;
}

.commentArea .notice {
  font-size: 0.6rem;
  line-height: 0.8rem;
  color: #666666;
  padding: 0px 16px 8px 16px;
}

.commentArea .errorArea {
  margin: -4px 16px 4px 16px;
  color: red;
}

@media screen and (max-width:640px) {
  .drawer {
    position: fixed;
    height: 100vh;
    top: auto;
    bottom: 0px;
    right: 0px;
    left: 0px;
    width: 100vw;
  }

  .drawer-leave-active,
  .drawer-enter-active {
    transition: bottom 0.3s;
  }

  .drawer-leave-active,
  .drawer-enter-active {
    transition: bottom 0.3s;
  }

  /* 表示アニメーション */
  .drawer-enter {
    bottom: -100vh;
  }
  .drawer-enter-to {
    bottom: 0px;
  }

  /* 非表示アニメーション */
  .drawer-leave {
    bottom: 0px;
  }
  .drawer-leave-to {
    bottom: -100vh;
  }
}
.nameArea button.disabled,
.button.disabled {
  opacity: 0.2;
  cursor: default;
}
.nameArea .signout {
  margin: 0px 8px;
}
.noMessage {
  font-size: 0.8rem;
  width: 100%;
  padding-top: 30%;
  text-align: center;
  color: gray;
}
</style>
